<script lang="ts">
	import { Counter, Icon } from '@repo/ui'
	import { ChevronDown } from '@steeze-ui/heroicons'

	interface Props {
		isOpen?: boolean
		groupedRight?: boolean
		groupedLeft?: boolean
		dropdownIcon?: boolean
		name?: string | null
		disabled?: boolean
		small?: boolean
		role?: string
		tabindex?: number
		count?: number
		onclick?: (Event) => void
		onkeydown?: (Event) => void
		onmousedown?: (Event) => void
		ontouchstart?: (Event) => void
		children?: import('svelte').Snippet
	}

	let {
		isOpen = false,
		groupedRight = false,
		groupedLeft = false,
		dropdownIcon = false,
		name = null,
		disabled = false,
		small = false,
		role = 'button',
		tabindex = 0,
		children,
		onclick = null,
		onkeydown = null,
		onmousedown = null,
		ontouchstart = null,
		count = null,
	}: Props = $props()
</script>

<button
	class="
    flex items-center {small ? 'gap-x-1.5' : 'gap-x-2'} whitespace-nowrap
    {groupedRight ? '' : 'rounded-r-lg'}
    {groupedLeft ? '' : 'rounded-l-lg'}
    {small ? 'px-2.5 py-1' : 'w-full px-4 py-2'}
    border text-right text-base text-gray-900
    {disabled ? 'opacity-50' : 'hover:bg-gray-100 dark:hover:bg-gray-800'}
     dark:bg-gray-900 dark:text-gray-200
    {isOpen ? 'border-primary-500 bg-primary-50' : 'border-gray-200 bg-white dark:border-gray-500 '}
  "
	data-test={name ? `button-${name}` : null}
	{onclick}
	{onkeydown}
	{onmousedown}
	{ontouchstart}
	{role}
	{tabindex}
>
	{@render children?.()}

	{#if dropdownIcon && !disabled}
		<span class="flex text-gray-400" class:rotate-180={isOpen}>
			<Icon class="dark:text-white" src={ChevronDown} />
		</span>
	{/if}

	{#if count}
		<Counter {small}>
			{count}
		</Counter>
	{/if}
</button>
